import { required } from "vuelidate/lib/validators";
export default {
    spkb_detail_form: {
        true: {
            spkbForm: {
                delivery_date: { required },
                driver: { required },
                delivery_to: { required },
                send_to_dc: { required },
                invoice_pic: { required },
                spkb_type: { },
                notes: {}
            },
            spkbDetailForm: {
                order_number: { required }
            }
        },
        false: {
            spkbForm: {
                delivery_date: { required },
                driver: { required },
                delivery_to: { required },
                send_to_dc: {},
                invoice_pic: { required },
                spkb_type: { },
                notes: {}
            },
            spkbDetailForm: {
                order_number: { required }
            }
        }
    },
    customer_details: {
        customer_group_indomaret_detail_true: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: { required },
                bill_address: { required },
                source_delivery: { },
                route_delivery: { required },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required }
            }
        },
        customer_group_indomaret_detail_false: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: { required },
                bill_address: { required },
                source_delivery: { },
                route_delivery: { required },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required }
            }
        },
        customer_group_notindomaret_detail_true: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { },
                vehicle_delivery_id: { },
                customer_code: {},
                bill_address: { },
                source_delivery: { },
                route_delivery: { },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required }
            }
        },
        customer_group_notindomaret_detail_false: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { },
                vehicle_delivery_id: { },
                customer_code: {},
                bill_address: { },
                source_delivery: { required },
                route_delivery: { },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required }
            }
        }
    },
    employee: {
        true: {
            employeeForm: {
                name: { required },
                surename: {},
                username: {},
                email: { required },
                start_join: { required },
                end_date: {},
                mobile_phone: { required },
                division_id: { required },
                position_id: { required },
                payment_method: { required },
                bank_account_number: { required },
                address: { required },
                id_number: { required },
                bank_account_name: {},
                bank_name: { required },
                parent: {},
                status: {},
                authorization: {},
                employee_ho: { required },
                religion: { required },
                shift: { required },
                company: { required }
            }
        },
        false: {
            employeeForm: {
                name: { required },
                surename: {},
                username: { required },
                email: { required },
                start_join: { required },
                end_date: {},
                mobile_phone: { required },
                division_id: { required },
                position_id: { required },
                payment_method: { required },
                bank_account_number: { required },
                address: { required },
                id_number: { required },
                bank_account_name: {},
                bank_name: { required },
                parent: {},
                status: {},
                authorization: {},
                employee_ho: { required },
                religion: { required },
                shift: { required },
                company: { required }
            }
        }
    },
    customer: {
        true: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: {  },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: {  },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: {  },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required } 
            }
        },
        false: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: {  },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: {  },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: {},
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required } 
            }
        }
    },
    assets: {
        add: {
            assetForm: {
                asset_owner_id: { required },
                serial_number: { required },
                file: { },
                description: {},
                status:{required},
                image_information: {},
            }
        },
        edit: {
            assetForm: {
                asset_owner_id: { required },
                serial_number: { required },
                file: { },
                description: {},
                status: {required},
                image_information: {},
            }
        }
    },
    task: {
        add: {
            taskCoverageForm: {
                employee_id: { required },
                related_non_gt: { },
                related_gt: { }
            }
        },
        edit: {
            taskCoverageForm: {
                employee_id: { required },
                related_non_gt: { },
                related_gt: { }
            }
        }
    },

    migrationTask: {
        add: {
            taskMigrationForm: {
                assigned_to: { required },
                assigned_prev: { required }
            }
        },
        edit: {
            taskMigrationForm: {
                assigned_to: { required },
                assigned_prev: { required }
            }
        }
    }
}